import React from "react";
import { useTranslation } from "react-i18next";
import AnimatedCol from "../../../../../../components/AnimatedCol";
import Aussendurchmesser from "../../general/Aussendurchmesser";
import Biegesteifigkeit from "../../general/Biegesteifigkeit";
import CharakteristischeFestigkeit from "../../general/CharakteristischeFestigkeit";
import Dehnsteifigkeit from "../../general/Dehnsteifigkeit";
import EModul from "../../general/EModul";
import Imperfektionsbeiwert from "../../general/Imperfektionsbeiwert";
import Innendurchmesser from "../../general/Innendurchmesser";
import QuerschnittStahltragglied from "../../general/QuerschnittStahltragglied";
import Traegheitsmoment from "../../general/Traegheitsmoment";
import TeilsicherheitsbeiwertTragglied from "./TeilsicherheitsbeiwertTragglied";
import Widerstandsmoment from "./Widerstandsmoment";

function ParameterTragglied({ expand, traggliedDaten, berechneteKnickenWerte, ym }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "inner.buckling.ofner.parameterTragglied",
  });
  const hide = `${expand ? "box" : "d-sm-none"} `;

  return (
    <div>
      <div className="row">
        <div className={`${hide} col-md-12`}>
          <h1>{t("headline")}</h1>
        </div>
      </div>
      <div className="row">
        <div className={`${hide} col-md-12`} style={{ paddingBottom: 15 }}>
          <p>{t("headlineSub")}</p>
        </div>
      </div>

      <div className="row">
        <AnimatedCol expand={expand}>
          <QuerschnittStahltragglied querschnitt={traggliedDaten?.querschnitt} />
        </AnimatedCol>
        <AnimatedCol expand={expand}>
          <Innendurchmesser innendurchmesser={traggliedDaten?.knicken?.innendurchmesser} />
        </AnimatedCol>
        <AnimatedCol expand={expand}>
          <Aussendurchmesser aussendurchmesser={berechneteKnickenWerte?.aussendurchmesser} />
        </AnimatedCol>
        <AnimatedCol expand={expand}>
          <Dehnsteifigkeit dehnsteifigkeit={traggliedDaten?.knicken?.dehnsteifigkeit} />
        </AnimatedCol>
        <AnimatedCol expand={expand}>
          <EModul e_modul={berechneteKnickenWerte?.elastizitaetsmodul} />
        </AnimatedCol>
        <AnimatedCol expand={expand}>
          <Traegheitsmoment traegheitsmoment={berechneteKnickenWerte?.traegheitsmoment} />
        </AnimatedCol>
        <AnimatedCol expand={expand}>
          <Biegesteifigkeit biegesteifigkeit={traggliedDaten?.knicken?.biegesteifigkeit} />
        </AnimatedCol>
        <AnimatedCol expand={expand}>
          <Widerstandsmoment widerstandsmoment={berechneteKnickenWerte?.widerstandsmoment} />
        </AnimatedCol>
        <AnimatedCol expand={expand}>
          <Imperfektionsbeiwert />
        </AnimatedCol>
        <AnimatedCol expand={expand}>
          <CharakteristischeFestigkeit
            charakteristischeFestigkeit={berechneteKnickenWerte?.charakteristischeFestigkeit}
          />
        </AnimatedCol>
        <AnimatedCol expand={expand}>
          <TeilsicherheitsbeiwertTragglied teilsicherheitsbeiwertTragglied={ym} />
        </AnimatedCol>
      </div>
    </div>
  );
}

export default ParameterTragglied;
